import { LuMoveUpRight } from "react-icons/lu";

import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card } from "@/components/ui/card";

interface PostCardMiniProps {
  image: string;
  category: string;
  title: string;
  excerpt: string;
  avatar: string;
  author: string;
  publishedAt: Date;
  slug: string;
  className?: string;
}

export function PostCardMini({
  image,
  category,
  title,
  excerpt,
  avatar,
  author,
  publishedAt,
  slug,
  className,
}: PostCardMiniProps) {
  const formattedSlug = slug.split("/").pop() || slug;
  const formattedDate = new Date(publishedAt).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  return (
    <Card
      className={`sm:min-w-sm bg-accent relative flex h-full w-full flex-col gap-6 p-6 shadow-xl ${className}`}
    >
      <div className="relative w-full overflow-hidden rounded-xl">
        <AspectRatio ratio={3 / 2}>
          <img
            src={image}
            alt={title}
            className="inset-0 h-full w-full rounded-xl"
            style={{ clipPath: "polygon(0 0, 100% 0, 100% 66%, 0 85%)" }}
          />
        </AspectRatio>
      </div>
      <div className="custom:flex-[0.7] sm:flex-[0.5]">
        <p className="text-primary font-semibold">{category}</p>
        <a href={`/blog/${formattedSlug}`} className="group">
          <div className="flex justify-between gap-6">
            <span className="mt-5 text-xl font-semibold sm:text-2xl md:text-3xl">
              {title}
            </span>
            <LuMoveUpRight
              size={25}
              className="translate-y-4 transition-transform group-hover:translate-x-1"
            />
          </div>
        </a>
        <p className="text-muted-foreground mt-5 font-medium">{excerpt}</p>
        <div className="mt-7 flex items-center gap-4">
          <img
            src={avatar}
            alt={author}
            className="h-10 w-10 rounded-full object-cover"
          />
          <div>
            <p className="text-sm font-semibold">{author}</p>
            <p className="text-muted-foreground text-sm">{formattedDate}</p>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default PostCardMini;
